
(function(){
  function hydratePjAssets(root){
    if(!root) return;
    var assets = window.PJ_WBF_ASSETS || {};
    var map = {
      'pj-asset-woman-body-foam':'woman-body-foam.png',
      'pj-asset-woman-body-wash':'woman-body-wash.png',
      'pj-asset-medical-body-foam':'medical-body-foam.png',
      'pj-asset-usage-delicate':'usage-delicate.png',
      'pj-asset-usage-underarm':'usage-underarm.png',
      'pj-asset-usage-legs':'usage-legs.png',
      'pj-asset-usage-back':'usage-back.png'
    };

    Object.keys(map).forEach(function(cls){
      var url = assets[map[cls]];
      if(!url) return;
      root.querySelectorAll('.'+cls).forEach(function(img){ img.src = url; });
    });

    // Fallback even if Shopify's editor strips custom data attributes/classes.
    var fallback = [
      ['.pj-product-frame img','woman-body-foam.png'],
      ['.pj-usage-v37-hero-img img','usage-delicate.png'],
      ['.pj-usage-v37-subgrid .pj-usage-v37-sub:nth-child(1) img','usage-underarm.png'],
      ['.pj-usage-v37-subgrid .pj-usage-v37-sub:nth-child(2) img','usage-legs.png'],
      ['.pj-usage-v37-subgrid .pj-usage-v37-sub:nth-child(3) img','usage-back.png'],
      ['.pj-mini-shot img[alt*="Woman Body Foam"]','woman-body-foam.png'],
      ['.pj-mini-shot img[alt*="Woman Body Wash"]','woman-body-wash.png'],
      ['.pj-mini-shot img[alt*="Medical Body Foam"]','medical-body-foam.png'],
      ['.pj-final-mini img','woman-body-foam.png']
    ];
    fallback.forEach(function(pair){
      var url = assets[pair[1]];
      if(!url) return;
      root.querySelectorAll(pair[0]).forEach(function(img){ img.src = url; });
    });
  }

  function initPjPageMode(){
    var root = document.getElementById('pj-wbf-guide');
    if(!root) return;
    document.body.classList.add('pj-wbf-page');

    var node = root.parentElement;
    while(node && node !== document.body && node.tagName !== 'MAIN'){
      node.classList.add('pj-wbf-host-reset');
      node = node.parentElement;
    }

    hydratePjAssets(root);

    // Move the floating CTA outside page/rte wrappers so overflow/stacking cannot clip it.
    var floating = document.getElementById('pj-floating-askai');
    if(floating && floating.parentElement !== document.body){
      document.body.appendChild(floating);
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initPjPageMode, {once:true});
  }else{
    initPjPageMode();
  }
})();

(function(){
  const OFFICIAL = {
    product: 'https://piajour.shop/products/woman-body-foam',
    compare: 'https://piajour.shop/pages/compare',
    faq: 'https://piajour.shop/pages/faq'
  };

  function promptText(){
    const lp = location.protocol.startsWith('http')
      ? location.href.split('#')[0]
      : 'https://piajour.shop/pages/woman-body-foam-guide';

    return `これまでの会話で分かっている私のことがあれば踏まえて、pia jour Woman Body Foamが私に合うか、以下の公式ページを確認して判断してください。合う点・合わない点と、必要なら他の選択肢も教えてください。医療判断ではなく、日常のケア用品選びとして答えてください。
https://piajour.shop/products/woman-body-foam`;
  }

  function track(eventName, provider, position){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event:eventName,
      provider:provider || undefined,
      page_type:'woman_body_foam_special_lp',
      position:position || 'bottom'
    });
  }

  function showToast(message){
    const toast = document.getElementById('pj-toast');
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(window.__pjToastTimer);
    window.__pjToastTimer = setTimeout(()=>toast.classList.remove('show'),2800);
  }

  // Synchronous copy: more reliable from a direct click, including local HTML previews.
  function syncCopy(text){
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly','');
    ta.setAttribute('aria-hidden','true');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    ta.style.top = '0';
    ta.style.opacity = '0';
    document.body.appendChild(ta);

    const selection = document.getSelection();
    const oldRange = selection && selection.rangeCount ? selection.getRangeAt(0) : null;

    ta.focus();
    ta.select();
    ta.setSelectionRange(0, ta.value.length);

    let ok = false;
    try{
      ok = document.execCommand('copy');
    }catch(e){
      ok = false;
    }

    ta.remove();

    if(oldRange && selection){
      try{
        selection.removeAllRanges();
        selection.addRange(oldRange);
      }catch(e){}
    }
    return ok;
  }

  // Last-resort panel: visible, selected prompt so the user can copy manually.
  function showManualCopy(text){
    let panel = document.getElementById('pj-manual-copy');
    if(!panel){
      panel = document.createElement('div');
      panel.id = 'pj-manual-copy';
      panel.style.cssText = [
        'max-width:860px','margin:18px auto 0','text-align:left',
        'background:#fff','border:1px solid #ef9aa5','border-radius:12px',
        'padding:16px'
      ].join(';');

      const label = document.createElement('p');
      label.textContent = '自動コピーできなかったため、下の相談文をコピーしてください。';
      label.style.cssText = 'margin:0 0 10px;font-size:.78rem;color:#6f686a';

      const area = document.createElement('textarea');
      area.id = 'pj-manual-copy-text';
      area.readOnly = true;
      area.style.cssText = [
        'width:100%','min-height:180px','resize:vertical',
        'border:1px solid #f0dadd','border-radius:10px','padding:12px',
        'font-size:16px','line-height:1.6'
      ].join(';');

      panel.appendChild(label);
      panel.appendChild(area);

      const guide = document.getElementById('pj-gemini-guide');
      const aiBox = document.querySelector('.pj-ai .pj-container') || document.body;
      if(guide && guide.parentNode){
        guide.parentNode.insertBefore(panel, guide.nextSibling);
      }else{
        aiBox.appendChild(panel);
      }
    }

    const area = document.getElementById('pj-manual-copy-text');
    area.value = text;
    area.focus();
    area.select();
  }

  const chatgpt = document.getElementById('pj-chatgpt-link');
  const gemini = document.getElementById('pj-gemini-link');
  const guide = document.getElementById('pj-gemini-guide');
  const copyButton = document.getElementById('pj-copy-prompt');

  function setChatGPTLink(){
    if(!chatgpt) return;
    const q = encodeURIComponent(promptText());
    chatgpt.href = 'https://chatgpt.com/?q=' + q + '&hints=search';
  }

  if(chatgpt) chatgpt.addEventListener('click', function(){
    track('ask_ai_chatgpt_click','chatgpt','bottom');
  });

  // Gemini: COPY FIRST while the click gesture is active, THEN open Gemini.
  if(gemini) gemini.addEventListener('click', function(e){
    e.preventDefault();
    track('ask_ai_gemini_click','gemini','bottom');

    const text = promptText();
    const copied = syncCopy(text);

    if(copied){
      if(guide){
        guide.textContent = '相談文をコピーしました。開いたGeminiの入力欄に貼り付けてください。';
        guide.classList.add('is-active');
      }
      showToast('相談文をコピーしました');
    }else{
      if(guide){
        guide.textContent = '自動コピーできなかったため、相談文を選択状態で表示しました。コピー後にGeminiへ貼り付けてください。';
        guide.classList.remove('is-active');
      }
      showManualCopy(text);
      showToast('自動コピーできませんでした');
    }

    // コピー成否にかかわらず、ユーザー操作内でGeminiを開く
    window.open('https://gemini.google.com/app', '_blank', 'noopener,noreferrer');
  });

  if(copyButton) copyButton.addEventListener('click', function(){
    track('ask_ai_copy_click','copy','bottom');
    const text = promptText();
    const copied = syncCopy(text);

    if(copied){
      showToast('AIへの質問文をコピーしました');
    }else{
      showManualCopy(text);
      showToast('自動コピーできませんでした');
    }
  });


  const productLink = document.getElementById('pj-askai-product-link');
  if(productLink){
    productLink.addEventListener('click', function(){
      track('ask_ai_product_click','product','after_ask_ai');
    });
  }

  setChatGPTLink();
})();





(function(){
  function setupPjFloatingV48(){
    var btn = document.getElementById('pj-floating-askai');
    var ask = document.getElementById('ask-ai');
    if(!btn || btn.dataset.v48Ready === '1') return;
    btn.dataset.v48Ready = '1';

    if(btn.parentElement !== document.body){ document.body.appendChild(btn); }

    btn.addEventListener('click', function(e){
      if(ask){
        e.preventDefault();
        ask.scrollIntoView({behavior:'smooth', block:'start'});
      }
    });

    function update(){
      var y = window.scrollY || window.pageYOffset || 0;
      var hide = y < 90;
      if(ask){
        var askTop = ask.getBoundingClientRect().top;
        var viewportH = window.innerHeight || document.documentElement.clientHeight || 0;
        if(askTop <= viewportH - 72){ hide = true; }
      }
      btn.classList.toggle('is-hidden', hide);
    }

    update();
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', setupPjFloatingV48, {once:true});
  }else{
    setupPjFloatingV48();
  }
  document.addEventListener('shopify:section:load', setupPjFloatingV48);
})();
